import {
    AutocompleteProps,
    AutocompleteRenderGetTagProps,
    Chip,
    ChipTypeMap,
} from '@mui/material';
import classNames from 'classnames';
import { MouseEvent, useCallback } from 'react';
import styles from './useCustomTagsStyles.module.scss';

export const useCustomTags = <
    T extends { label: string; key?: string; id?: string },
    Multiple extends boolean | undefined,
>(props?: {
    onTagClick?: (ev: MouseEvent<HTMLElement>, value: T) => void;
}) => {
    const onTagClick = props?.onTagClick;
    const renderTags: AutocompleteProps<
        T,
        Multiple,
        false,
        false,
        ChipTypeMap['defaultComponent']
    >['renderTags'] = useCallback(
        (values: T[], getTagProps: AutocompleteRenderGetTagProps) =>
            values.map((value, index) => {
                const chipProps = getTagProps({ index });
                const onClick = onTagClick
                    ? (ev: MouseEvent<HTMLElement>) => {
                          onTagClick(ev, value);
                      }
                    : undefined;

                return (
                    <Chip
                        {...chipProps}
                        className={classNames(styles.chip, chipProps.className)}
                        size="small"
                        variant="outlined"
                        label={value.label}
                        key={value.key ?? value.id ?? `${value.label}-${index}`}
                        onClick={onClick}
                    />
                );
            }),
        [onTagClick],
    );

    return { renderTags };
};
